<script setup lang="ts">
import { AppFlicker, AppMasonryGallery, GalleryButtonType } from '@libs/ui';

import type { PeekPriceLargeHotelCardData } from '../models';

import PeekPriceHotelRooms from './PeekPriceHotelRooms.vue';

interface PeekPriceMediumHotelCardProps {
  data: PeekPriceLargeHotelCardData;
}

const props = defineProps<PeekPriceMediumHotelCardProps>();
</script>

<template>
  <div class="peek-price-medium-hotel-card">
    <div class="time-section">
      <div class="date-text">{{ props.data.dates }}</div>
      <div class="nights-text">{{ props.data.nights }}</div>
    </div>

    <AppMasonryGallery
      :image-urls="props.data.imageUrls"
      :alt-image-text="$t('a11y.image')"
      :gallery-button="{ type: GalleryButtonType.NoButton }"
      orientation="horizontal"
      class="hotel-gallery"
    />

    <div class="hotel-name-text">{{ props.data.hotelName }}</div>
    <div class="hotel-destination-text">
      {{ props.data.hotelDestination }}
    </div>

    <PeekPriceHotelRooms v-if="props.data.rooms" :rooms="props.data.rooms" />
    <div v-else class="rooms-flicker">
      <AppFlicker height="100%" width="spacing-48" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.peek-price-medium-hotel-card {
  .time-section {
    display: flex;
    margin-bottom: var(--spacing-8);

    .date-text {
      @include font-label-s-light;
      color: var(--color-neutral-70);
      padding-right: var(--spacing-8);
      border-right: 1px solid var(--color-neutral-20);
      margin-right: var(--spacing-8);
    }

    .nights-text {
      @include font-label-s-light;
      color: var(--color-neutral-70);
    }
  }

  .hotel-gallery {
    height: 173px;
    margin-bottom: var(--spacing-12);
  }

  .hotel-name-text {
    @include font-label-m-bold;
    color: var(--color-neutral-70);
    margin-bottom: var(--spacing-4);
  }

  .hotel-destination-text {
    @include font-label-s-light;
    color: var(--color-neutral-70);
    margin-bottom: var(--spacing-16);
  }

  .rooms-flicker {
    height: 18px;
  }
}
</style>
